import * as React from 'react';
import styled from 'styled-components';
import * as ethers from 'ethers';
import { useTranslation } from 'react-i18next';
import { BackupAddress } from '../../components/00nftbackupcard/backupAddressComponent';
import { BackupcardTitle } from '../../components/00nftbackupcard/backupcardTitleComponent';
import { QrcodeBackUp } from '../../components/00nftbackupcard/qrcode/qrcodeComponent';
import { SaveBackupcardDoneButton } from '../../components/00nftbackupcard/saveBackupcardDoneComponent';
import { LargeField } from '../../components/largeField';
import { CloseButtonChakra } from '../../components/closeButtonChakraComponent';

import { Center, Box, Text } from '@chakra-ui/react';
import { useRecoilValue } from 'recoil';
import { configJsonState } from '../../states/configJsonState';

type Props = {}

export const BackupcardPage: React.FC<Props> = (props) => {
  const privateKey = localStorage.getItem('privateKey');
  const address = privateKey ? new ethers.Wallet(privateKey).address : '';
  const [browserWalletStatus, setBrowserWalletStatus] = React.useState(address);
  const configStatus = useRecoilValue(configJsonState);
  const [saveButtonStatus, setSaveButtonStatus] = React.useState('flex');
  const [saveDoneButtonStatus, setSaveDoneButtonStatus] = React.useState('none');
  const [t, i18n] = useTranslation();
  const BackupcardPageComponent = styled.main`
    text-align: center;
    color: white;
    font-family: 'Noto Sans JP', sans-serif;
    background-repeat: no-repeat;
    background-size: 100% auto;
    backdrop-filter: blur(12px);
    display: grid;
    justify-content: center;
    flex-wrap: wrap;

    background-image: url(${configStatus.backgroundImage});
    height: 100vh;
  `;

  return (
    <BackupcardPageComponent>
        <Center h={`100vh`}>
          <LargeField id='backupcard'>
              <BackupcardTitle />
              <Text
                textAlign={'start'}
                fontWeight={'bold'}
                mb={'15px'}
              >
                <Box as='span' color={'red'}>{t(`スクリーンショット`)}</Box>{t(`で`)}<br/>{t(`保存してください`)}<br/>{t(`NFTを復元するために必要です`)}
              </Text>
              <QrcodeBackUp/>
              <BackupAddress backupCardAddress={`address:${browserWalletStatus.substring(0,14)}...`}/>
              <Text
                fontWeight={'bold'}
              >
                {t('※他の人に共有しないでください')}
              </Text>
              <Box 
                display={'flex'}
                justifyContent={'space-between'}
                width={'250px'}
              >
                <CloseButtonChakra/>
                <SaveBackupcardDoneButton saveButtonStatus={saveButtonStatus} saveDoneButtonStatus={saveDoneButtonStatus}/>
              </Box>
          </LargeField>
        </Center>
    </BackupcardPageComponent>
  );
};
